import { createReducer } from 'services/reduxHelpers'
import { sourceTypes } from 'reduxModules/actions/SourceActions'

/* ------------- Initial State ------------- */

export const initialState = {
  sources: [],
  monthSourcesData: [],
  isLoading: false
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [sourceTypes.GET_SOURCES_ATTEMPT]: () => ({
    isLoading: true
  }),
  [sourceTypes.GET_SOURCES_SUCCESS]: (_, { data }) => ({
    sources: data,
    isLoading: false
  }),
  [sourceTypes.GET_SOURCES_FAILURE]: () => ({
    isLoading: false
  }),

  [sourceTypes.CLEAR_SOURCES_ATTEMPT]: () => ({
    sources: []
  }),

  [sourceTypes.SUBSCRIBE_MONTH_SOURCES_DATA_SUCCESS]: (_, { data }) => ({
    monthSourcesData: data
  }),

  [sourceTypes.UPDATE_MONTH_SOURCES_DATA_SUCCESS]: (_, { data }) => ({
    monthSourcesData: data
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/SourceReducer.js